import { WallLateralDatumAnchorAll, lateralDatumInwardWallLayers } from "building-types/datums/datumsTypes";
import type { RoomOutlines } from "building-types/rooms/roomOutlineTypes";
import { WallLayerType } from "building-types/walls/wallEnums";
import { assertUnreachable } from "common/utils/assertUnreachable";
import type { PolyLine2 } from "geom/polyLine2Types";
import { wallLateralDatumAnchorToWallLayer } from "../elements/wallLateralDatumAnchorToWallLayer";

/**
 * Returns the polyline outline for a lateral datum. If the lateral datum is
 * is not associated with an outline, the room outline is returned.
 */
export function wallLayerOutlineFromLateralDatum(
  room: { outline: PolyLine2 },
  roomOutlines: RoomOutlines | undefined,
  lateralDatum: WallLateralDatumAnchorAll,
): PolyLine2 {
  if (lateralDatum === WallLateralDatumAnchorAll.ROOM_EDGE) {
    return room.outline;
  }

  if (lateralDatum === WallLateralDatumAnchorAll.WALL_OFFSET) {
    return roomOutlines?.INSIDE_OF_MASS_MAX_OFFSET || room.outline;
  }

  const isInwardWallLayer = lateralDatumInwardWallLayers[lateralDatum];

  if (isInwardWallLayer) {
    const wallLayer = wallLateralDatumAnchorToWallLayer[lateralDatum];
    if (wallLayer === undefined) {
      return room.outline;
    }
    switch (wallLayer) {
      // these all have the same outline at the moment
      case WallLayerType.FINISH:
      case WallLayerType.SUBSTRATE:
      case WallLayerType.MASS:
        return roomOutlines?.INSIDE_OF_MASS || room.outline;
      case WallLayerType.STRUCTURE:
        return roomOutlines?.INSIDE_OF_STRUCTURE || room.outline;
      default:
        assertUnreachable(wallLayer);
    }
  }

  return room.outline;
}
